export const EVENT_ID_REGEX = /^\/+/;
// Email validation regex
export const EMAIL_VALIDATION_REGEX = /^[+a-zA-Z0-9_.!#$%&'*/=?^`{|}~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,63}$/;

// Regex for separating multiple email addresses from input (comma or semicolon separated)
export const EMAIL_SEPARATOR_REGEX = /[,;]+/;

// Regex for matching invalid email characters (to be removed from input)
export const VALID_EMAIL_CHARS_REGEX = /[^a-zA-Z0-9@._+\-!#$%&'*/=?^`{|}~,;]/g;

// Regex for removing all whitespace characters from strings
export const WHITESPACE_REMOVE_REGEX = /\s+/g;
